export const makeInventoryKey = (model, bodyStyle) => {
	const m = (model ?? '').trim();
	const b = (bodyStyle ?? '').trim();
	return b ? `${m}|${b}` : m;
};

const findValueIgnoreCase = (counts, key) => {
	if (!key) return undefined;
	const normalized = key.toLowerCase();
	const entries = Object.entries(counts);
	for (let i = 0; i < entries.length; i += 1) {
		if (entries[i][0].toLowerCase() === normalized) {
			return entries[i][1];
		}
	}
	return undefined;
};

// Checks whether any composite key (model|*) exists in the counts map.
const hasAnyCompositeForModel = (counts, model) => {
	const prefix = `${(model ?? '').trim().toLowerCase()}|`;
	return Object.keys(counts).some((k) => k.toLowerCase().startsWith(prefix));
};

// Composite-first, fall back to bare model so a missing breakdown
// degrades to today's behavior instead of returning 0. Lookup is
// case-insensitive to tolerate any casing drift between vehicle data
// (gvBodyStyle, model) and WIS facet values (normalBodyStyle, model).
export const lookupInventoryCount = (counts, model, bodyStyle) => {
	if (!counts) return 0;
	const composite = makeInventoryKey(model, bodyStyle);
	const compositeValue = findValueIgnoreCase(counts, composite);
	if (compositeValue !== undefined) return compositeValue;
	// If a bodyStyle was requested and other composite keys exist for this
	// model, the absence of this specific composite means 0 inventory —
	// do NOT fall back to the bare-model total.
	if (bodyStyle && hasAnyCompositeForModel(counts, model)) {
		return 0;
	}
	const bare = (model ?? '').trim();
	return findValueIgnoreCase(counts, bare) ?? 0;
};
